import { observer } from 'mobx-react-lite';

import { GlobalItem, GlobalMM2Item } from '@/shared/types/common';
import { Illustration } from '@/shared/ui';

import styles from './select-chroma-variant.module.scss';

export const SelectChromaVariantFeature = observer(
  ({ item }: { item: GlobalItem | GlobalMM2Item }) => {
    return (
      <div
        onClick={e => {
          e.stopPropagation();
          alert('chroms');
        }}
      >
        <Illustration
          spriteName={'icons'}
          name={'tag-chroma'}
          spanTagClassName={styles['chroma-tag']}
        />
      </div>
    );
  },
);
